var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-container", [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c("div", { staticClass: "column w-75" }, [
            _c(
              "div",
              {
                staticClass:
                  "mt-4 d-flex align-items-start justify-content-between"
              },
              [
                _c("back-arrow", {
                  attrs: { title: _vm.$t("my.lampions.title") }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column justify-content-center mt-4 mb-4"
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-center w-100" },
                  [
                    _c("div", { staticClass: "page-title lampions-nb mr-2" }, [
                      _vm._v(_vm._s(_vm.lampionsInfos.lampionsUser))
                    ]),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "coin-image mt-2",
                      attrs: {
                        src: require("@/assets/images/b122/ic_coin.png")
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "currentLoopGrades mt-1" },
                  _vm._l(_vm.lampionsInfos.currentLoopGrades, function(
                    loopGrade
                  ) {
                    return _c(
                      "span",
                      {
                        class:
                          loopGrade.gradeName ===
                          _vm.lampionsInfos.currentGradeName
                            ? "currentLoopGrade"
                            : ""
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(loopGrade.gradeName) +
                            "\n                  "
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _c("div", { staticClass: "currentLevel mt-1 mb-2" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("level")) +
                      " " +
                      _vm._s(_vm.lampionsInfos.currentLevelNumber) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "w-100 d-flex flex-column align-items-center"
                  },
                  [
                    _c(
                      "b-progress",
                      {
                        staticClass: "w-100 lampions-progress",
                        attrs: {
                          max: _vm.lampionsInfos.nbPointsInCurrentLevel,
                          "no-value": ""
                        }
                      },
                      [
                        _c("b-progress-bar", {
                          staticClass: "lampions-progress-bar",
                          attrs: { value: _vm.lampionsInfos.currentNbOfPoints }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "lampions-progress-value" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.lampionsInfos.currentNbOfPoints) +
                          " / " +
                          _vm._s(_vm.lampionsInfos.nbPointsInCurrentLevel) +
                          "\n            "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "three-match-warning mt-1 mb-2" }, [
                  _c("span", { staticClass: "main-grey-light-color" }, [
                    _vm._v(_vm._s(_vm.$t("my.lampions.warning")))
                  ]),
                  _vm._v(
                    " " + _vm._s(_vm.$t("my.lampions.3.tries")) + "\n          "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "my-progress-title mt-4" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("my.lampions.my.progress")) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "loops mt-3 mb-2" },
                  _vm._l(_vm.lampionsInfos.loops, function(loop, index) {
                    return index >= _vm.currentLoopIndex
                      ? _c("div", { key: index, staticClass: "loop" }, [
                          _c("div", { staticClass: "flex-container" }, [
                            _c("div", {
                              staticClass: "vertical-line",
                              class: {
                                "hidden-bar": index === _vm.currentLoopIndex
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "circle",
                              class: {
                                "lampions-progress-bar":
                                  index === _vm.currentLoopIndex
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "vertical-line",
                              class: {
                                "hidden-bar":
                                  index === _vm.lampionsInfos.loops.length - 1
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "loopName" }, [
                            _vm._v(_vm._s(loop.name))
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$t("from.level")) +
                                " " +
                                _vm._s(loop.levelMin) +
                                " " +
                                _vm._s(_vm.$t("to")) +
                                " " +
                                _vm._s(loop.levelMax)
                            )
                          ])
                        ])
                      : _vm._e()
                  }),
                  0
                )
              ]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09b4b949", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09b4b949","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/MyLampions.vue
// module id = Oa0w
// module chunks = 0